import { createServerFn } from "@tanstack/react-start";

// createServerFn keeps this on the server — on the client it becomes an RPC call.
// The dynamic import() prevents @convex-dev/better-auth/react-start (which pulls in
// @tanstack/start-server-core and its virtual modules) from entering the client bundle.
export const getToken = createServerFn({ method: "GET" }).handler(async () => {
	const { convexBetterAuthReactStart } =
		await import("@convex-dev/better-auth/react-start");
	const auth = convexBetterAuthReactStart({
		convexUrl: import.meta.env.VITE_CONVEX_URL,
		convexSiteUrl: import.meta.env.VITE_CONVEX_SITE_URL,
	});
	const token = await auth.getToken();
	return token ?? null;
});

// Only used in server route handlers (api/auth/$).
export const handler = async (request: Request) => {
	const { convexBetterAuthReactStart } =
		await import("@convex-dev/better-auth/react-start");
	const auth = convexBetterAuthReactStart({
		convexUrl: import.meta.env.VITE_CONVEX_URL,
		convexSiteUrl: import.meta.env.VITE_CONVEX_SITE_URL,
	});
	return auth.handler(request);
};
